import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import ReactPlayer from "react-player"
import { BodyCopy, StyledHeading } from "../common"

const StyledBlogCard = styled(Link)`
  border-top: 8px solid ${(props) => props.color || "#005d73"};
  padding-top: 3rem;
  display: grid;
  h3,
  h5 {
    color: #005d73;
  }
  span {
    color: #005d73;
    font-size: 14px;
    font-weight: 700;
    align-self: flex-end;
    margin-top: 1rem;
  }
`

export const BlogCard = ({
  portal_image,
  title,
  url,
  excerpt,
  category = {},
  featured_video_url,
}) => {
  const { category_color, title: categoryTitle } =
    (category?.document && category?.document?.data) || {}

  return (
    <StyledBlogCard color={category_color} to={url}>
      <BodyCopy>
        {categoryTitle && (
          <StyledHeading size="h5" as="h5" ttu>
            {categoryTitle?.text}
          </StyledHeading>
        )}
        <StyledHeading size="h3" as="h3" weight={800}>
          {title?.text}
        </StyledHeading>

        <div dangerouslySetInnerHTML={{ __html: excerpt?.html }} />
      </BodyCopy>
      {featured_video_url ? (
        <div
          style={{
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "auto",
            maxHeight: "200px",
            aspectRatio: "16/9",
          }}
        >
          <ReactPlayer
            url={featured_video_url}
            playing={true}
            playsinline={false}
            width="100%"
            height="100%"
            style={{
              objectFit: "cover",
            }}
            loop={true}
            muted={true}
          />
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              zIndex: 10,
              width: "100%",
              height: "100%",
              background: "#00000030",
            }}
          />
          <svg
            style={{ position: "absolute" }}
            width="43"
            height="43"
            viewBox="0 0 43 43"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_1_320)">
              <path
                d="M21.5 43C25.7523 43 29.9091 41.739 33.4448 39.3766C36.9804 37.0141 39.7361 33.6563 41.3634 29.7277C42.9907 25.7991 43.4165 21.4761 42.5869 17.3055C41.7573 13.1349 39.7096 9.30401 36.7028 6.29718C33.696 3.29035 29.865 1.24268 25.6944 0.413096C21.5239 -0.416487 17.2009 0.009285 13.2723 1.63657C9.34369 3.26385 5.98585 6.01956 3.6234 9.55522C1.26095 13.0909 0 17.2477 0 21.5C0 27.2021 2.26517 32.6707 6.2972 36.7028C10.3292 40.7348 15.7978 43 21.5 43ZM21.5 2.36262C25.285 2.36262 28.985 3.485 32.1321 5.58784C35.2793 7.69068 37.7322 10.6795 39.1806 14.1764C40.6291 17.6733 41.0081 21.5212 40.2696 25.2335C39.5312 28.9458 37.7086 32.3557 35.0322 35.0321C32.3558 37.7085 28.9458 39.5312 25.2335 40.2696C21.5212 41.008 17.6733 40.6291 14.1764 39.1806C10.6796 37.7321 7.6907 35.2792 5.58786 32.1321C3.48502 28.985 2.36264 25.285 2.36264 21.5C2.36186 18.9866 2.85633 16.4977 3.8178 14.1755C4.77927 11.8533 6.18889 9.74331 7.96611 7.96609C9.74333 6.18887 11.8533 4.77925 14.1755 3.81778C16.4977 2.85631 18.9866 2.36184 21.5 2.36262Z"
                fill="white"
              />
              <path
                d="M15.18 30.1236C15.3748 30.2445 15.6006 30.3061 15.8297 30.3008C16.0121 30.2898 16.1915 30.25 16.3613 30.1827L31.305 22.8585C31.5067 22.766 31.6763 22.6154 31.792 22.426C31.9077 22.2366 31.9644 22.0171 31.9547 21.7953C31.949 21.5837 31.8923 21.3766 31.7895 21.1915C31.6866 21.0064 31.5407 20.8488 31.3641 20.7321L16.7157 12.8173C16.5312 12.7296 16.3294 12.6841 16.1251 12.6841C15.9207 12.6841 15.719 12.7296 15.5344 12.8173C15.3552 12.9166 15.2058 13.0621 15.102 13.2387C14.9981 13.4153 14.9434 13.6165 14.9438 13.8214L14.5894 29.0604C14.6006 29.2709 14.6597 29.476 14.762 29.6602C14.8644 29.8444 15.0073 30.0029 15.18 30.1236Z"
                fill="white"
              />
            </g>
            <defs>
              <rect width="43" height="43" fill="white" />
            </defs>
          </svg>
        </div>
      ) : (
        <span>READ MORE</span>
      )}
    </StyledBlogCard>
  )
}
